import React from 'react'


const PageNotFound = () =>{

    return(
        <div className='404'>
            <h1>404 error page not found loll!!!</h1>
        </div>
    )




}

export default PageNotFound